import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SharedWalletModal from '../../../../../website/components/shared/WalletModal/WalletModal';
import { Routes } from '../../../constants/routes';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { buildWalletsBucketThunk } from '../../../store/reducers/Wallet/slice';
import { displayName } from '../../LabelBox/LabelBox';
import Modal from '../../Modal/Modal';
import PrivacyPolicy from '../../PrivacyPolicy/PrivacyPolicy';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import WalletBox from '../../WalletBox/WalletBox';
import { walletItems } from '../../WalletBox/WalletBoxIcons';
import styles from './WalletModal.module.scss';
const walletTabs = [{ name: 'wallet' }];
const WalletModal = ({ onClose, isStatic = false, updateWalletsOnMount = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { walletsBucket, walletsUpdating } = useSelector((state) => state.wallet);
    const onModalRedirect = useCallback(() => {
        navigate(Routes.STABLES);
    }, [navigate]);
    const onModalCloseFn = useMemo(() => (onClose ? onClose : onModalRedirect), [onClose, onModalRedirect]);
    const [cookies] = useCookies();
    useEffect(() => {
        updateWalletsOnMount && dispatch(buildWalletsBucketThunk({ walletItems, cookies }));
    }, [dispatch, updateWalletsOnMount]);
    const { address } = useAppSelector((state) => state.wallet.activeWallet);
    const [activeElem] = useState(walletTabs[0].name);
    const userInfo = useAppSelector((state) => state.app.userInfo);
    const PrivacyElement = (_jsx(PrivacyPolicy, { className: styles.privacy, text: t('connect_crypto_wallet'), textEnd: t('equine_terms_of_service') }));
    const WalletItems = (_jsx("div", { children: walletsBucket
            .filter(({ isAvailable }) => isAvailable)
            .map((walletBucketItem, idx) => (_jsx(WalletBox, Object.assign({}, walletBucketItem, { isUpdating: walletsUpdating }), idx))) }));
    return (_jsx(Modal, Object.assign({ className: styles.element, background: true, closeModal: onModalCloseFn, isStatic: isStatic }, { children: _jsx(SharedWalletModal, { activeElem: activeElem, connectText: t('connect_wallet'), Privacy: PrivacyElement, address: address ? (_jsxs("div", Object.assign({ className: styles.wallet }, { children: [_jsx(Paragraph, { title: displayName((userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || '', address) }), _jsx(Paragraph, { color: 'grey', size: 1, fontFamily: 'urbanist', title: address })] }))) : (_jsx(Paragraph, { className: 'text-center w-100', title: t('connect_wallet') })), WalletItems: WalletItems }) })));
};
export default WalletModal;
